import Controller from '@ember/controller';
import { beebeeAjaxPost, beebeeAjaxGet } from 'beebee-base/lib/utility';

import { notifyUserError } from 'beebee-base/lib/utility';

import { action, computed, set } from '@ember/object';

import { task, timeout } from 'ember-concurrency';

import { inject as iService } from '@ember/service';

import { inject as iController } from '@ember/controller';
import moment from 'moment-timezone';

import getConfig from 'beebee-base/lib/get-config';
export default class GuidePersonalDataController extends Controller {
  @iService notify;
  queryParams = ['contact_id', 'project_id'];
  @iService router;
  @iService intl;
  @iService session;
  @iService store;
  @iService log;
  @iController('application') applicationController;

  steps = [
    {
      name: 'guide.intro',
      number: 1,
      status: 'active',
    },
    {
      name: 'guide.base_data',
      number: 2,
      status: '',
    },
    {
      name: 'guide.advanced_data_label',
      number: 3,
      status: '',
    },
    {
      name: 'completed',
      number: 4,
      status: '',
    },
  ];

  @computed('steps.@each.status')
  get stepSelected() {
    return this.steps.find((i) => i.status === 'active');
  }

  @(task(function* () {
    yield timeout(250);

    if (!this.session.token || !this.project_id) {
      return;
    }

    try {
      const PHCustomData = yield beebeeAjaxGet(
        `${getConfig(this).APP.urlApi}/peakshunter_timeline/${this.project_id}`,
        this.session.token
      );

      const langMap = {
        francese: 'fr-fr',
        inglese: 'en-gb',
        italiano: 'it-it',
      };

      let lang = PHCustomData?.prenotazione?.lang || 'inglese';

      if (lang && langMap[lang]) {
        this.applicationController.switchLangTask.perform(langMap[lang]);
      }

      this.setPHData(PHCustomData);

      this.applicationController.setProperties({
        'content.open_organization': this.store.queryRecord('organization', 'open'),
      });
    } catch (e) {
      this.log.warn('loadDataTask: load failed', e);
    }
  }).restartable())
  loadDataTask;

  setPHData(PHCustomData) {
    if (!PHCustomData.utente_principale) {
      PHCustomData.partecipanti = (PHCustomData.partecipanti ?? []).filter(
        (item) => item.id === PHCustomData.loggato
      );
      PHCustomData.principale = [];
    }

    set(this, 'PHCustomData', PHCustomData);
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  recreateTextAddressTask(p) {
    let {
      location_address_street,
      location_address_house,
      location_address_postal_code,
      location_address_city,
      location_address_country,
    } = p;

    let newAddressText = `${location_address_street ?? ''} ${location_address_house ?? ''}<br/>${location_address_postal_code ?? ''} ${location_address_city ?? ''}<br/>${location_address_country ?? ''}`;
    return newAddressText;
  }

  checkFields() {
    var self = this;

    const requiredFieldsPartecipanti = [
      'last_name',
      'first_name',
      'mail',
      'mobile',
      'data_nascita',
      'luogo_nascita',
      'location_address_street',
      'location_address_house',
      'location_address_postal_code',
      'location_address_city',
      'location_address_country',
      'location_address_country_code',
    ];
    const requiredFieldsPrincipale = [
      'last_name',
      'first_name',
      'mail',
      'mobile',
      'data_nascita',
      'luogo_nascita',
      'location_address_street',
      'location_address_house',
      'location_address_postal_code',
      'location_address_city',
      'location_address_country',
      'location_address_country_code',
      'contact',
    ];

    let foundEmpty = false;

    (this.PHCustomData.partecipanti || []).forEach((partecipante) => {
      set(partecipante, 'requiredEmpty', {});

      requiredFieldsPartecipanti.forEach((field) => {
        if (!partecipante[field] || partecipante[field].trim() === '') {
          if (field.includes('location_')) {
            set(partecipante.requiredEmpty, 'address', true);
          } else {
            set(partecipante.requiredEmpty, field, true);
          }
          foundEmpty = true;
        }
        if (field === 'mail' && !self.isValidEmail(partecipante[field])) {
          set(partecipante.requiredEmpty, field, true);
          foundEmpty = true;
        }

        if (field === 'mobile' && !partecipante['isMobileValid']) {
          set(partecipante.requiredEmpty, field, true);
          foundEmpty = true;
        }
      });

      set(partecipante, 'location_address_text', self.recreateTextAddressTask(partecipante));

      if (!Array.isArray(partecipante.campi_avanzati)) {
        partecipante.campi_avanzati = [];
      }
    });

    (this.PHCustomData.principale || []).forEach((principale) => {
      set(principale, 'requiredEmpty', {});

      requiredFieldsPrincipale.forEach((field) => {
        if (!principale[field] || principale[field].trim() === '') {
          if (field.includes('location_')) {
            set(principale.requiredEmpty, 'address', true);
          } else {
            set(principale.requiredEmpty, field, true);
          }
          foundEmpty = true;
        }

        if (field === 'mail' && !self.isValidEmail(principale[field])) {
          set(principale.requiredEmpty, field, true);
          foundEmpty = true;
        }

        if (field === 'mobile' && !principale['isMobileValid']) {
          set(principale.requiredEmpty, field, true);
          foundEmpty = true;
        }

        if (field === 'contact' && !principale['isContactValid']) {
          set(principale.requiredEmpty, field, true);
          foundEmpty = true;
        }

        if (
          (principale.location_address_country || '').toLowerCase() === 'italia' &&
          (!principale.cod_fiscale || principale.cod_fiscale.trim() === '')
        ) {
          set(principale.requiredEmpty, 'cod_fiscale', true);
          foundEmpty = true;
        }
      });

      set(principale, 'location_address_text', self.recreateTextAddressTask(principale));
    });

    return foundEmpty;
  }

  checkAdvancedFields() {
    let foundEmpty = false;

    (this.PHCustomData.partecipanti || []).forEach((partecipante) => {
      set(partecipante, 'requiredAdEmpty', false);
      if (
        !this.PHCustomData.utente_principale ||
        (this.PHCustomData.utente_principale && !partecipante.invio_richiesta_dati)
      ) {
        if (Array.isArray(partecipante.campi_avanzati)) {
          partecipante.campi_avanzati.forEach((ca) => {
            if (!ca) return;
            set(ca, 'requiredAdEmpty', false);

            if (!ca.value || ca.value.trim() === '') {
              set(ca, 'requiredAdEmpty', true);
              set(partecipante, 'compilazione', 'manuale');
              foundEmpty = true;
            }
          });
        }
      }
    });

    return foundEmpty;
  }

  @(task(function* (stepNumber) {
    yield timeout(250);

    try {
      yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/peakshunter_booking_step`, this.session.token, {
        timeline: this.PHCustomData,
        step: stepNumber,
      });
    } catch (e) {
      this.log.error('saveStepTask failed', e);
      notifyUserError(this.notify, e, this.intl);
      // Report the refusal to the caller: a settled task is not a stored step.
      return false;
    }
  }).restartable())
  saveStepTask;

  @(task(function* (p) {
    yield timeout(250);

    try {
      const PHCustomData = yield beebeeAjaxPost(
        `${getConfig(this).APP.urlApi}/peakshunter_send_request`,
        this.session.token,
        {
          contact_id: p.id,
          project_id: this.project_id,
          mail: p.mail,
          product_name: this.PHCustomData?.prenotazione?.product_name,
          contact_name: `${p.first_name} ${p.last_name}`,
        }
      );

      this.setPHData(PHCustomData);
      this.notify.success('Richiesta inviata');
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
      return false;
    }
  }).restartable())
  reqAvanzatiTask;

  @(task(function* () {
    const contact_id = [41672];

    const wrapObj = `${this.session.me?.label} dati completati`;
    const wrapMessage = `<strong>${this.session.me?.label}</strong> ha completato i dati richiesti<br /><br />
    Prenotazione: <a href="https://${this.session.me?.organization?.organization}.beebeeboard.com/guide_segreteria/view/projects/${this.PHCustomData?.prenotazione?.id}">${this.PHCustomData?.prenotazione?.product_name}</a><br />
    Data gita: ${moment(this.PHCustomData?.prenotazione?.data_gita).format('ddd DD/MM/YYYY')}<br />
    Partecipanti: ${this.PHCustomData?.prenotazione?.num_partecipanti}PAX<br />
    Durata: ${this.PHCustomData?.prenotazione?.duration} giorni<br />
    <br />
    DEBUG: ${JSON.stringify(this.PHCustomData, null, 2)}`;

    try {
      yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/mail`, this.session.token, {
        object: wrapObj,
        text: wrapMessage,
        sms_number: null,
        contact_id,
        mail: 'info@peakshunter.com',
        number: null,
        massive: false,
        organization_name: this.session.me?.organization?.name,
        thumbnail_url: this.session.me?.organization?.thumbnail_url,
        color: this.session.me?.organization?.primary_color,
        lang: this.intl.primaryLocale,
      });
    } catch (e) {
      this.log.error('guide-personal-data: intercom/boot data failed', e);
    }
  }).restartable())
  sendMailPHTask;

  @task(function* (direction) {
    const stepActive = this.steps.find((i) => i.status === 'active');

    let foundEmpty = null;
    if (stepActive?.number === 2) {
      foundEmpty = this.checkFields();
    } else if (stepActive?.number === 3) {
      foundEmpty = this.checkAdvancedFields();
      if (!foundEmpty && getConfig(this).environment === 'production') {
        yield this.sendMailPHTask.perform();
      }
    }

    if (direction === 'next' && foundEmpty) {
      return;
    }

    if (direction === 'next' && stepActive.number > 1) {
      const saved = yield this.saveStepTask.perform(stepActive.number);
      // saveStepTask swallows the POST failure, so a settled task said nothing
      // about whether the timeline was stored: the wizard marked the step
      // completed and moved on while the server had taken none of the data.
      // Test `=== false` — the success path resolves undefined.
      if (saved === false) {
        return;
      }
    }

    const newIndex = direction === 'next' ? stepActive.number + 1 : stepActive.number - 1;

    for (let i = 0; i < this.steps.length; i++) {
      let step = this.steps[i];
      if (step.number < newIndex) {
        set(step, 'status', 'completed');
      } else if (step.number === newIndex) {
        set(step, 'status', 'active');
      } else {
        set(step, 'status', '');
      }
    }
  })
  nextStepTask;

  @action
  clickLogo() {}
}
